import axios from "axios";
import qs from "qs";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

const authHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handle401 = (err) => {
  if (err.response?.status === 401 && onUnauthorized) onUnauthorized();
  throw err;
};

export const $get = async (endpoint = "", params = {}) => {
  try {
    return await axios.get(API_URL + "/" + endpoint, {
      params,
      headers: authHeader(),
    });
  } catch (e) {
    handle401(e);
  }
};

export const $post = async (endpoint = "/", body = {}) => {
  try {
    return await axios({
      method: "post",
      url: API_URL + "/" + endpoint,
      headers: { "Content-Type": "application/x-www-form-urlencoded", ...authHeader() },
      data: qs.stringify(body),
    });
  } catch (e) {
    handle401(e);
  }
};

export const $put = async (endpoint = "/", body = {}) => {
  try {
    return await axios({
      method: "put",
      url: API_URL + "/" + endpoint,
      headers: { "Content-Type": "application/x-www-form-urlencoded", ...authHeader() },
      data: qs.stringify(body),
    });
  } catch (e) {
    handle401(e);
  }
};

export const $delete = async (endpoint = "/", body = {}) => {
  try {
    return await axios({
      method: "delete",
      url: API_URL + "/" + endpoint,
      headers: { "Content-Type": "application/x-www-form-urlencoded", ...authHeader() },
      data: qs.stringify(body),
    });
  } catch (e) {
    handle401(e);
  }
};
